import { useTranslation } from 'react-i18next';
import { ChangeEvent, useEffect, useState } from 'react';
import styled from 'styled-components';
import DatePickerComponent from './DatePicker';
import { toast } from 'react-toastify';
import { v4 } from 'uuid';
import { BtnBlue, BtnRed } from './Button';
import FormatImg from './FormatImg';
import { downloadFile, setupFlutterFileHandlers } from '../utils/flutterBridge';
import SearchSelectBoxSm from './SearchSelectBoxSm';
import FileUploadButton from './button/FileUploadButton';
import { formatDateToStr, formatDateYMD } from '../utils/formatDate';
import { applyBorderStyle } from '../utils/applyBorderStyle';
import { isIOS } from '../utils/checkMobile';

const ServiceReportTable = styled.div`
  width: 774px;
  max-width: 774px;
  margin: 0 auto;
  background: var(--board);

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;

    td {
      // border: 1px solid var(--text-primary) !important;
      border-right: 1px solid var(--text-primary) !important;
      border-bottom: 1px solid var(--text-primary) !important;
      border-top: none !important;
      border-left: none !important;
      padding: 6px;
      text-align: center;
      vertical-align: middle;
      word-break: keep-all;
      font-size: 13px;
      line-height: 1.3;
      color: var(--text-primary);

      pre {
        width: 100%;
        white-space: pre-wrap;
        word-break: break-all;
        line-height: 1.4;
        color: var(--text-primary);
      }

      p,
      span {
        line-height: 1.4;
        color: var(--text-primary);
      }

      &.border-left {
        border-left: 1px solid var(--text-primary) !important;
      }

      &.border-top {
        border-top: 1px solid var(--text-primary) !important;
      }

      &.sign-filed {
        background: rgba(255, 255, 255, 0.5);
        color: #000;

        > div {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        span {
          color: #000;
        }
      }
    }

    td > div.min-height {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      min-height: 100px;
    }

    .header-title {
      padding: 1rem 0;
    }

    .border-none {
      border: none !important;
    }

    .form-title {
      background: var(--tonal);
    }

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }

    .px-0 {
      padding-left: 0;
      padding-right: 0;
    }

    .install-form {
      > td {
        padding: 6px 2px;
      }
    }

    .product-name {
      word-break: keep-all;
    }

    .manager-sign-img {
      position: absolute;
      top: -10px;
      left: 50px;
      width: 56px;
      margin-left: -18px;
    }

    .sign-img-wrap {
      position: absolute;
      top: -9px;
      left: 50px;
      width: 80px;
      height: 34px;
      margin-left: -30px;

      &.sign-img-outline {
        border: 1px solid var(--primary);
        background: var(--tonal-blue);
      }

      .sign-img {
        width: 100%;
      }
    }

    .confirm td {
      border-color: #ab88c5;
      background: #e9e2ec;
    }

    input[type='checkbox'] + label > span {
      font-size: 13px;
      letter-spacing: 0.1px;
    }

    input[type='checkbox'] {
      opacity: 0;
      pointer-events: none;
      margin: 0;
      box-sizing: border-box;
      min-width: 18px;
      min-height: 18px;
    }

    input[type='checkbox'] + label {
      margin: 0;
      font-size: 13px;
      position: relative;
      cursor: pointer;
      color: var(--text-primary);
      background: transparent;
    }

    input[type='checkbox'] + label::before {
      content: '';
      min-width: 16px;
      min-height: 16px;
      position: absolute;
      top: 3px;
      left: -22px;
      border-radius: 3px;
      border: 1px solid var(--text-primary);
      transition: all 0.4s;
      background: transparent;
      z-index: 99;
    }

    .check-box-cont {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      background: transparent;
      border: 1px solid var(--text-primary);
      border-radius: 4px;

      &.checked {
        background: var(--text-primary);
      }

      .material-symbols-rounded {
        font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 24;
        color: var(--text-reverse);
        font-size: 1.25rem;
      }
    }

    /*
    input[type='checkbox'] + label svg {
      position: absolute;
      width: 20px;
      left: -22px;
      top: 1px;
    }

    input[type='checkbox'] + label svg polyline {
      stroke: white;
      stroke-width: 8;
      fill: none;
      stroke-dasharray: 70;
      stroke-dashoffset: 70;
      transition: stroke-dashoffset 0.4s;
    }

    input[type='checkbox']:checked + label::before {
      background-color: #191516;
    }

    input[type='checkbox']:checked + label svg polyline {
      stroke-dashoffset: 0;
    }
    */

    @media screen and (max-width: 768px) {
      /*
    & {
      width: 1200px;
      transform: scale(0.6);
      transform-origin: center center;
      /* td {
        padding: 0.5vw;
        font-size: 0.875vw;
        line-height: 1.2;
      } */
      /* } */
    }
  }

  .file-download-wrap {
    width: 100%;

    h5 {
      padding: 0.5rem 0;
      border-bottom: 2px solid var(--text-primary);
    }

    .file-download-inner {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      width: 100%;
      padding: 0.5rem 0;

      .file-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .file {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          width: 100%;
          min-width: 65%;

          span {
            width: calc(100% - 36px);
            font-size: 0.875rem;
            color: var(--text-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5;
          }
        }

        button {
          width: auto;
          height: auto;
          padding: 0.5rem;

          span {
            font-size: 0.875rem;
          }
        }
      }
    }

    @media screen and (max-width: 1024px) {
      h5 {
        font-size: 5vw;
        padding: 3vw 0;
      }

      .file-download-inner {
        gap: 3vw;
        padding: 3vw 0;

        .file-item {
          .file {
            svg {
              width: 8vw;
              height: auto;
            }
            span {
              font-size: 4vw;
            }
          }

          button {
            padding: 2vw;

            span {
              font-size: 4vw;
            }
          }
        }
      }
    }
  }
`;

const ServiceReportForm = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;

  .form-group-wrap {
    padding-bottom: 1rem;

    h5 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.5rem 0;
      border-bottom: 2px solid var(--text-primary);
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      width: 100%;
      padding: 0.5rem 0;

      .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        > input {
          width: 75%;
        }

        &.search-select-wrap {
          > div {
            width: 75%;

            > ul {
              width: 100%;

              > li {
                width: 100%;
                max-width: 100%;

                > span {
                  font-size: 1rem;
                }
              }
            }
          }
        }

        .quantity-date-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          width: 75%;

          input {
            width: calc(50% - 0.25rem);
          }

          .quantity-date-item {
            position: relative;
            width: calc(50% - 0.25rem);

            .date-remove-btn {
              position: absolute;
              right: 0.5rem;
              top: 50%;
              transform: translateY(-50%);
              background: none;
              border: none;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--text-tertiary);
            }
          }
        }

        .file-upload-wrap {
          display: flex;
          flex-direction: column;
          width: 75%;
          gap: 0.5rem;

          .file-upload-btn {
            display: flex;
            width: 100%;
          }

          .file-wrap {
            width: 100%;

            .file-inner {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
            }

            .file-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;

              .file {
                display: flex;
                align-items: center;
                width: 100%;
                min-width: 65%;
                gap: 0.5rem;

                svg {
                  flex: 1;
                }

                span {
                  width: calc(100% - 36px);
                  color: var(--text-primary);
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }

              .file-btn {
                padding: 0.5rem;
                height: auto;

                span {
                  font-size: 0.875rem;
                }
              }
            }
          }
        }

        label:not(.file-upload-label) {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          width: 25%;

          .required-star {
            color: var(--filled-red);
          }
        }

        > textarea {
          width: 75% !important;
        }

        textarea {
          width: 100%;
          min-height: 100px;
          border-radius: 0.25rem;
          background: var(--tonal);
          color: var(--text-primary);
          font-size: 1rem;
          border: none;
          padding: 0.875rem;
          resize: none;
        }

        .datePickerWrapper {
          width: 75%;
        }

        .text-info-cont {
          width: 75%;
          text-align: left;
        }

        &.fix-info-item {
          padding: 0.5rem 0;
        }

        &.install-form-item {
          padding: 0.5rem 0;
          border-top: 1px solid var(--outline);

          > label {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            position: sticky;
            top: 0;
            z-index: 10;

            .remove-row-btn {
              height: auto;
              text-decoration: underline dotted;
              text-underline-offset: 0.25rem;
              color: var(--filled-red);
              font-size: 14px;
              cursor: pointer;
            }

            @media screen and (max-width: 768px) {
              flex-direction: row;
              align-items: center;
            }
          }

          &:last-child {
            border-bottom: 1px solid var(--outline);
          }

          .install-item {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            width: 75%;

            select {
              height: 58px;
            }

            .item-filed-group {
              display: flex;
              gap: 0.5rem;
              width: 100%;

              .item-filed {
                width: 50%;
              }

              .input-text {
                width: 50%;
              }
            }

            .item-filed {
              position: relative;

              label {
                display: flex;
                align-items: center;
                position: absolute;
                top: 16px;
                left: 0;
                padding: 0 0.75rem;
                color: var(--text-tertiary);
                user-select: none;
                pointer-events: none;
                transition: ease-out 0.3s;
              }

              input {
                height: 58px;
                padding: 1.5rem 0.75rem 0.5rem;
              }

              input:focus + label,
              input:not(:placeholder-shown) + label {
                font-size: 12px;
                transform: translateY(-12px);
                transition: ease-in 0.3s;
              }
            }
          }

          @media screen and (max-width: 768px) {
            > label {
              width: 100%;
              top: -1rem;
              padding: 0.5rem 0;
              background: var(--board);
            }
          }
        }
      }
    }

    .add-row-button-wrapper {
      border-radius: 0.5rem;
      border: 1px dashed var(--outline);
      padding: 0.5rem 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        background: rgba(0, 0, 0, 0.03);
        border-color: var(--primary);
      }
    }
  }

  @media screen and (max-width: 768px) {
    .form-group-wrap {
      .form-group {
        gap: 1rem;

        .form-item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          width: 100%;

          > textarea {
            width: 100% !important;
          }

          .text-info-cont,
          > input,
          &.search-select-wrap > div,
          .datePickerWrapper,
          .quantity-date-list,
          &.install-form-item .install-item {
            width: 100%;
          }

          label {
            width: 100%;
            text-align: left;
          }

          input {
            height: 3.2rem;
            font-size: 16px;
          }

          &.search-select-wrap > div {
            height: 48px;

            > ul {
              height: 100%;

              > li {
                height: 100%;
              }
            }
          }

          &.fix-info-item {
            padding: 0.25rem 0;

            .text-info-cont {
              font-size: 1.25rem;
            }
          }

          .file-upload-wrap {
            width: 100%;
          }
        }
      }

      .add-row-button-wrapper {
        padding: 1rem;
      }
    }
  }
`;

interface ServiceReportProps {
  form: IServiceReport;
  setForm: (val: IServiceReport | ((prev: IServiceReport) => IServiceReport)) => void;
  signSrc?: string;
  isEdit?: boolean;
  handleInstallChange?: (idx: number, key: string, value: any) => void;
  addInstallRow?: () => void;
  handleMaintenanceChange?: (idx: number, key: string, value: any) => void;
  addMaintenanceRow?: () => void;
  removeMaintenanceRow?: (idx: number) => void;
  removeInstallRow?: (idx: number) => void;
  mainManagerCd?: any;
  setMainManagerCd?: (val: any) => void;
  subManagerCd?: any;
  setSubManagerCd?: (val: any) => void;
  mainManagerOptions?: any;
  setMainManagerOptions?: (val: any) => void;
  subManagerOptions?: any;
  setSubManagerOptions?: (val: any) => void;
  setDeleteFileIndex?: (val: number[]) => void;
  deleteFileIndex?: number[];
  isSignView?: boolean;
  signManagerNameRef?: React.RefObject<HTMLInputElement>;
  signManagerPhoneRef?: React.RefObject<HTMLInputElement>;
  isSaveClicked?: boolean;
}

const unitOptions = [
  { value: '', label: '단위 선택' },
  { value: 'EA', label: 'EA' },
  { value: 'SET', label: 'SET' },
  { value: '식', label: '식' },
];

export const gubunOptions = [
  { value: '', label: '구분 선택' },
  { value: 'new', label: '설치' },
  { value: 'move', label: '이전' },
  { value: 'remove', label: '해체' },
  { value: 'repair', label: '회수' },
];

// mm/dd 형식을 YYYY-MM-DD 형식으로 변환 (input type='date'용)
const convertMMDDYYYYToYYYYMMDD = (mmddyyyy: string): string => {
  if (!mmddyyyy || mmddyyyy === '') return '';
  if (mmddyyyy.includes('/')) {
    const [month, day, year = ''] = mmddyyyy.split('/');
    const currentYear = new Date().getFullYear();
    return `${year !== '' ? year : currentYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  return '';
};

// YYYY-MM-DD 형식을 mm/dd/yyyy 형식으로 변환
const convertYYYYMMDDToMMDDYYYY = (yyyyMMdd: string): string => {
  if (!yyyyMMdd || yyyyMMdd === '') return '';
  // YYYY-MM-DD 형식인지 확인
  if (yyyyMMdd.includes('-')) {
    const [year, month, day] = yyyyMMdd.split('-');
    return `${month}/${day}/${year}`;
  }
  return '';
};

const ServiceReport = ({
  form,
  setForm,
  signSrc,
  isEdit = true,
  handleInstallChange,
  addInstallRow,
  handleMaintenanceChange,
  addMaintenanceRow,
  removeMaintenanceRow,
  removeInstallRow,
  mainManagerCd,
  setMainManagerCd,
  subManagerCd,
  setSubManagerCd,
  mainManagerOptions,
  setMainManagerOptions,
  subManagerOptions,
  setSubManagerOptions,
  setDeleteFileIndex,
  deleteFileIndex,
  isSignView,
  signManagerNameRef,
  signManagerPhoneRef,
  isSaveClicked,
}: ServiceReportProps) => {
  const { t } = useTranslation();
  const [maintenanceChecked, setMaintenanceChecked] = useState(form.isMaintenance);
  const [installChecked, setInstallChecked] = useState(form.isInstall);
  const [resizeIsMobile, setResizeIsMobile] = useState(false);
  const [completeDate, setCompleteDate] = useState(form?.completeDate?.replaceAll('-', '') || formatDateToStr(new Date()));

  const handleRemoveInstallRow = (idx: number) => {
    if (removeInstallRow) {
      removeInstallRow(idx);
    } else {
      // fallback - 컴포넌트 내부에서 처리
      setForm((prev) => {
        const updatedList = [...prev.installList];
        updatedList.splice(idx, 1);
        return {
          ...prev,
          installList: updatedList.length ? updatedList : [{ name: '', unit: '', qty: '', location: '', bigo: '', gubun: { name: '', gubun: '' }, date1: '', date2: '', date3: '', date4: '' }],
        };
      });
    }
  };

  useEffect(() => {
    setForm((prev) => ({ ...prev, isMaintenance: maintenanceChecked }));
  }, [maintenanceChecked]);

  useEffect(() => {
    setForm((prev) => ({ ...prev, isInstall: installChecked }));
  }, [installChecked]);

  useEffect(() => {
    if (form.completeDate) {
      setCompleteDate(form.completeDate.replaceAll('-', ''));
    }
    setMaintenanceChecked(form.isMaintenance);
    setInstallChecked(form.isInstall);
  }, [form]);

  useEffect(() => {
    setForm((prev) => ({ ...prev, completeDate }));
  }, [completeDate]);

  useEffect(() => {
    const handleResize = () => {
      setResizeIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // 휴대폰 번호 포멧 ( xxxyyyyzzzz -> xxx-yyyy-zzzz 변환 )
  const setPhoneNumber = (phone: string) => {
    if (!phone || phone === '') return '';
    // 하이픈이나 다른 문자들이 있는 경우 제거
    const phoneNumber = phone.replaceAll('-', '').replace(/\D/g, '');
    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  };

  // 파일 삭제
  const onClickFileRemove = (fileId: string) => {
    const deleteFile = form.scheduleRFList.find((file: IFile) => file.fileId === fileId && file.fUrl !== ''); // 삭제된 파일 값
    if (deleteFile) {
      setDeleteFileIndex?.([...(deleteFileIndex ?? []), Number(fileId)]);
    }
    setForm((prev: any) => ({ ...prev, scheduleRFList: prev.scheduleRFList.filter((file: IFile) => file.fileId !== fileId) }));
  };

  // 파일 다운로드
  const handleFileDownload = async (fileUrl: string, filename: string) => {
    try {
      await downloadFile(fileUrl, filename);
    } catch (err) {
      console.error('There was an error:', err);
    }
  };

  const fileDataSet = (e: ChangeEvent<HTMLInputElement>, set: any) => {
    const { files } = e.target;

    if (files) {
      const arr: number[] = Array.from({ length: files.length }, (_, i) => i);
      const fileOption: IFile[] = arr.map((currentIdx: number) => ({
        fileId: v4(),
        file: files[currentIdx],
        fileName: files[currentIdx].name,
        fileFormat: files[currentIdx].name.slice(files[currentIdx].name.lastIndexOf('.') + 1),
        fUrl: '',
      }));

      set((prev: any) => ({ ...prev, scheduleRFList: [...prev.scheduleRFList, ...fileOption] }));
      e.target.value = '';
    }

    return false;
  };

  // 첨부파일 업로드
  const onChangeFileUpload = async (e: ChangeEvent<HTMLInputElement> | undefined) => {
    if (e) {
      const { files } = e.target;

      if (files) {
        const arr: number[] = Array.from({ length: files.length }, (_, i) => i);
        const duplication: IFile[] = form.scheduleRFList.filter((file: IFile) => arr.some((currentIdx: number) => file.fileName === files[currentIdx].name));

        if (form.scheduleRFList.length >= 10) {
          e.target.value = ''; // 파일 필드 초기화
          toast.warn(t('업로드 가능한 파일 갯수는 최대 10개 입니다'));
          return false;
        }
        if (duplication.length > 0) {
          e.target.value = ''; // 파일 필드 초기화
          toast.warn(t('이미 불러온 파일입니다'));
          return false;
        }

        fileDataSet(e, setForm);
      }
    } else {
      // Flutter 파일 선택 처리
      try {
        if (window.FilePicker) {
          window.FilePicker.postMessage('all');
        }
      } catch (error) {
        console.error('파일 처리 에러:', error);
      }
    }
    return false;
  };

  useEffect(() => {
    const cleanup = setupFlutterFileHandlers(
      (fileData) => {
        const fileOption: IFile = {
          fileId: v4(),
          file: fileData.file,
          fileName: fileData.name,
          fileFormat: fileData.name.slice(fileData.name.lastIndexOf('.') + 1),
          fUrl: '',
        };
        if (form.scheduleRFList.length >= 10) {
          toast.warn(t('업로드 가능한 파일 갯수는 최대 10개 입니다'));
          return;
        }

        const duplication = form.scheduleRFList.find((f: IFile) => f.fileName === fileData.name);
        if (duplication) {
          toast.warn(t('이미 불러온 파일입니다'));
          return;
        }

        setForm((prev: any) => ({ ...prev, scheduleRFList: [...prev.scheduleRFList, fileOption] }));
      },
      (error) => {
        console.error('파일 선택 오류:', error);
      },
      undefined,
      'all'
    );

    return cleanup;
  }, [form.scheduleRFList]);

  const randomString = Math.random().toString(36).substring(7);

  return (
    <div style={{ backgroundColor: 'var(--board)' }}>
      {(isSignView && !form.signImg) || !isEdit ? (
        <ServiceReportTable className={`service-report-table ${window.FlutterWebView !== undefined ? 'flutter-table' : ''}`} id='screen'>
          <table>
            <tbody>
              <tr>
                <td colSpan={20} className='border-none' style={{ width: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <div className={`check-box-cont ${form.isInstall === 'Y' ? 'checked' : ''}`}>{form.isInstall === 'Y' && <span className='material-symbols-rounded'>check</span>}</div>
                      <span>Installation</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <div className={`check-box-cont ${form.isMaintenance === 'Y' ? 'checked' : ''}`}>{form.isMaintenance === 'Y' && <span className='material-symbols-rounded'>check</span>}</div>
                      <span>Maintenance</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={20} className='header-title border-none'>
                  <p>
                    <span style={{ fontSize: '28px' }}>
                      <strong>Service Report</strong>
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-top border-left'>
                  <p>고객사/현장</p>
                </td>
                <td colSpan={11} className='border-top'>
                  <p>
                    {form.hName} / {form.sName}
                  </p>
                </td>
                <td colSpan={2} rowSpan={2} className='form-title border-top'>
                  <p>현장담당</p>
                </td>
                <td colSpan={2} className='border-top'>
                  <p>{form.signManagerName}</p>
                </td>
                <td colSpan={2} className='border-top'>
                  <p>{form.signManagerPartname}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-left'>
                  <p>현장주소</p>
                </td>
                <td colSpan={11}>
                  <p>{form.address}</p>
                </td>
                <td colSpan={4}>
                  <p>{setPhoneNumber(form.signManagerPhone)}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={20} className='text-left border-none px-0'>
                  <p>
                    ▷유지보수<b>(Maintenance)</b>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-top border-left'>
                  <p>접수내역</p>
                </td>
                <td colSpan={17} className='text-left border-top'>
                  <p>{form.isMaintenance === 'Y' ? form.maintenanceTitle : ''}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-left'>
                  <p>증상및원인</p>
                </td>
                <td colSpan={6} className='text-left'>
                  <div className='min-height'>
                    <pre>{form.isMaintenance === 'Y' ? form.maintenanceCauses : ''}</pre>
                  </div>
                </td>
                <td colSpan={3} className='form-title'>
                  <p>조치사항</p>
                </td>
                <td colSpan={8} className='text-left'>
                  <pre>{form.isMaintenance === 'Y' ? form.maintenanceAction : ''}</pre>
                </td>
              </tr>
              <tr className='min-height'>
                <td colSpan={3} className='form-title border-left'>
                  <p>
                    자재(장비)
                    <br />
                    투입내역
                  </p>
                </td>
                <td colSpan={6} className='text-left'>
                  <div className='min-height'>
                    <pre>{form.isMaintenance === 'Y' ? form.useMaterial : ''}</pre>
                  </div>
                </td>
                <td colSpan={3} className='form-title'>
                  <p>비고</p>
                </td>
                <td colSpan={8} className='text-left'>
                  <div className='min-height'>
                    <pre>{form.isMaintenance === 'Y' ? form.bigo : ''}</pre>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={20} className='text-left border-none px-0'>
                  <p>
                    ▷설치 및 해체<b>(Installation)</b>
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-top border-left'>
                  <p>작업내역</p>
                </td>
                <td colSpan={17} className='text-left border-top'>
                  <p>{form.isInstall === 'Y' ? form.installTitle : ''}</p>
                </td>
              </tr>
              <tr className='install-form'>
                <td rowSpan={2} className='form-title border-left'>
                  <p>NO.</p>
                </td>
                <td colSpan={4} rowSpan={2} className='form-title'>
                  <p>품명</p>
                </td>
                <td rowSpan={2} className='form-title'>
                  <p>단위</p>
                </td>
                <td rowSpan={2} className='form-title'>
                  <p>
                    발주
                    <br />
                    수량
                  </p>
                </td>
                <td rowSpan={2} className='form-title'>
                  <p>구분</p>
                </td>
                <td colSpan={4} className='form-title'>
                  <p>일자별 작업수량</p>
                </td>
                <td colSpan={4} rowSpan={2} className='form-title'>
                  <p>작업위치</p>
                </td>
                <td colSpan={4} rowSpan={2} className='form-title'>
                  <p>비고</p>
                </td>
              </tr>
              <tr className='install-form'>
                {form.installDate.map((date: string, idx: number) => (
                  <td className='form-title' key={idx}>
                    <p>{form.isInstall === 'Y' ? (date !== '' ? date.slice(0, 5) : '/') : '/'}</p>
                  </td>
                ))}
              </tr>
              {[...(form.installList || []), ...((form.installList?.length || 0) < 10 ? Array.from({ length: 10 - (form.installList?.length || 0) }, (_, i) => i) : [])].map(
                (item: any, idx: number) => (
                  <tr key={item.name} className='install-form'>
                    <td className='border-left'>
                      <p>{idx + 1}</p>
                    </td>
                    <td className='product-name' colSpan={4}>
                      <p>{form.isInstall === 'Y' ? item?.name : ''}</p>
                    </td>
                    <td>
                      <p>{form.isInstall === 'Y' ? item?.unit : ''}</p>
                    </td>
                    <td>
                      <p>{form.isInstall === 'Y' ? item?.qty : ''}</p>
                    </td>
                    <td>
                      <p>
                        {form.isInstall === 'Y'
                          ? item?.gubun
                            ? gubunOptions.find((option: any) => option.value === (typeof item?.gubun === 'object' ? item?.gubun?.gubun : item?.gubun))?.label === '구분 선택'
                              ? ''
                              : gubunOptions.find((option: any) => option.value === (typeof item?.gubun === 'object' ? item?.gubun?.gubun : item?.gubun))?.label
                            : ''
                          : ''}
                      </p>
                    </td>
                    <td>
                      <p>{form.isInstall === 'Y' ? item?.date1 : ''}</p>
                    </td>
                    <td>
                      <p>{form.isInstall === 'Y' ? item?.date2 : ''}</p>
                    </td>
                    <td>
                      <p>{form.isInstall === 'Y' ? item?.date3 : ''}</p>
                    </td>
                    <td>
                      <p>{form.isInstall === 'Y' ? item?.date4 : ''}</p>
                    </td>
                    <td colSpan={4}>
                      <pre>{form.isInstall === 'Y' ? item?.location : ''}</pre>
                    </td>
                    <td colSpan={4}>
                      <pre>{form.isInstall === 'Y' ? item?.bigo : ''}</pre>
                    </td>
                  </tr>
                )
              )}
              <tr>
                <td colSpan={20} className='border-none'>
                  <div />
                </td>
              </tr>
              <tr>
                <td colSpan={8} className='border-top border-left'>
                  <p>상기와 같이 작업 완료하였음을 확인합니다.</p>
                </td>
                <td colSpan={12} className='border-top'>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <p>
                      작업완료일 : <span>{form.completeDate ? formatDateYMD(form.completeDate) : ''}</span>
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <div className={`check-box-cont ${form.isPaid === 'Y' ? 'checked' : ''}`}>{form.isPaid === 'Y' && <span className='material-symbols-rounded'>check</span>}</div>
                        <span>유상</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <div className={`check-box-cont ${form.isPaid === 'N' ? 'checked' : ''}`}>{form.isPaid === 'N' && <span className='material-symbols-rounded'>check</span>}</div>
                        <span>무상</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-left'>
                  <p>아이티로그확인</p>
                </td>
                <td colSpan={2} className='form-title'>
                  <p>담당(정)</p>
                </td>
                <td colSpan={6} className='sign-filed'>
                  <div>
                    <p>{form.mainManagerName}</p>
                    <span>
                      <b style={{ position: 'relative', paddingLeft: '50px' }}>
                        (인)
                        <img src={`${form.mainManagerSignUrl}?v=${randomString}`} alt='' className='manager-sign-img' crossOrigin='anonymous' />
                      </b>
                    </span>
                  </div>
                </td>
                <td colSpan={2} className='form-title'>
                  <p>담당(부)</p>
                </td>
                <td colSpan={7} className='sign-filed'>
                  <div>
                    <p>{form.subManagerName}</p>
                    <span>
                      <b style={{ position: 'relative', paddingLeft: '50px' }}>
                        (인)
                        <img src={`${form.subManagerSignUrl}?v=${randomString}`} alt='' className='manager-sign-img' crossOrigin='anonymous' />
                      </b>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className='form-title border-left'>
                  <p>담당자명</p>
                </td>
                <td colSpan={8} className='sign-filed'>
                  <div>
                    <p>{form.signManagerName}</p>
                    <span>
                      <b style={{ position: 'relative', paddingLeft: '50px' }}>
                        (인)
                        <div className={`sign-img-wrap ${isSignView ? 'sign-img-outline' : ''}`}>
                          <img src={form.signImg ? `${form.signImg}?v=${randomString}` : signSrc} alt='' className='sign-img' crossOrigin='anonymous' />
                        </div>
                      </b>
                    </span>
                  </div>
                </td>
                <td colSpan={2} className='form-title'>
                  <p>연락처</p>
                </td>
                <td colSpan={7}>
                  <p>{setPhoneNumber(form.signManagerPhone)}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={20} className='text-right border-none px-0'>
                  <b>(주)아이티로그</b>
                </td>
              </tr>
            </tbody>
          </table>

          {form.scheduleRFList.length > 0 && (
            <div className='file-download-wrap'>
              <h5>{t('첨부파일')}</h5>
              <div className='file-download-inner'>
                {form.scheduleRFList.map((el: IFile) => (
                  <div key={el.fileId} className='file-item'>
                    <div className='file'>
                      <FormatImg format={el.fileFormat} />
                      <span>{el.fileName}</span>
                    </div>
                    {el.fUrl !== '' && (
                      <BtnBlue className='file-btn' onClick={() => handleFileDownload(el.fUrl, el.fileName)}>
                        <span className='material-symbols-rounded'>download</span>
                      </BtnBlue>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </ServiceReportTable>
      ) : (
        <ServiceReportForm>
          <h4 style={{ textAlign: 'center', fontWeight: 'bold', margin: '0.5rem', color: 'var(--text-primary)' }}>Service Report</h4>
          <div className='form-group-wrap'>
            <h5>{t('기본 정보')}</h5>
            <div className='form-group'>
              <div className='form-item fix-info-item'>
                <label htmlFor='hName'>{t('고객사')}</label>
                <div className='text-info-cont'>
                  <span>{form.hName}</span>
                </div>
              </div>
              <div className='form-item fix-info-item'>
                <label htmlFor='sName'>{t('현장명')}</label>
                <div className='text-info-cont'>
                  <span>{form.sName}</span>
                </div>
              </div>
              <div className='form-item fix-info-item'>
                <label htmlFor='address'>{t('현장주소')}</label>
                <div className='text-info-cont'>
                  <span>{form.address}</span>
                </div>
              </div>
              <div className='form-item fix-info-item'>
                <label htmlFor='isPaid'>{t('유/무상')}</label>
                <div className='text-info-cont'>
                  <span>{form.isPaid === 'Y' ? t('유상') : t('무상')}</span>
                </div>
              </div>
              <div className='form-item'>
                <label htmlFor='siteManagerName'>
                  {t('현장 서명자')}
                  <b className='required-star'>*</b>
                </label>
                <input
                  type='text'
                  id='siteManagerName'
                  ref={signManagerNameRef}
                  value={form.signManagerName}
                  style={isSaveClicked ? applyBorderStyle(form.signManagerName, 'red', 'signManagerName') : undefined}
                  onChange={(e) => setForm({ ...form, signManagerName: e.target.value })}
                  placeholder={t('현장 서명자 입력')}
                />
              </div>
              <div className='form-item'>
                <label htmlFor='siteManagerPhone'>
                  {t('현장 서명자 연락처')}
                  <b className='required-star'>*</b>
                </label>
                <input
                  type='tel'
                  id='siteManagerPhone'
                  ref={signManagerPhoneRef}
                  value={form.signManagerPhone}
                  style={isSaveClicked ? applyBorderStyle(form.signManagerPhone, 'red', 'signManagerPhone') : undefined}
                  onChange={(e) => setForm({ ...form, signManagerPhone: e.target.value })}
                  placeholder={t('- 없이 연락처 입력')}
                />
              </div>
              <div className='form-item'>
                <label htmlFor='siteManagerPartname'>{t('현장 서명자 직함')}</label>
                <input
                  type='text'
                  id='siteManagerPartname'
                  // ref={siteManagerPartnameRef}
                  value={form.signManagerPartname}
                  onChange={(e) => setForm({ ...form, signManagerPartname: e.target.value })}
                  placeholder={t('현장 서명자 직함 입력')}
                />
              </div>
              <div className='form-item search-select-wrap'>
                <label htmlFor='companyManagerName'>{t('담당자(정)')}</label>
                <SearchSelectBoxSm
                  options={mainManagerOptions}
                  defaultOption={mainManagerCd.cdName || t('미선택')}
                  state={mainManagerCd}
                  setState={setMainManagerCd || (() => {})}
                  stateKey='mainManagerCd'
                  codeKey='cdName'
                  initiateKey={mainManagerCd.mainManagerCd}
                  optionHeight='height-md'
                />
              </div>
              <div className='form-item search-select-wrap'>
                <label htmlFor='companyManagerName'>{t('담당자(부)')}</label>
                <SearchSelectBoxSm
                  options={subManagerOptions}
                  defaultOption={subManagerCd.cdName || t('미선택')}
                  state={subManagerCd}
                  setState={setSubManagerCd || (() => {})}
                  stateKey='subManagerCd'
                  codeKey='cdName'
                  initiateKey={subManagerCd.subManagerCd}
                  optionHeight='height-md'
                />
              </div>
              <div className='form-item'>
                <label htmlFor='completeDate'>
                  {t('완료일')}
                  <b className='required-star'>*</b>
                </label>
                <div className='datePickerWrapper'>
                  <DatePickerComponent label='' type='date' startDate={completeDate} setDate={setCompleteDate} />
                </div>
              </div>
            </div>
          </div>

          <div className='form-group-wrap'>
            <h5>
              <input type='checkbox' id='maintenanceChk' checked={maintenanceChecked === 'Y'} onChange={() => setMaintenanceChecked(maintenanceChecked === 'Y' ? 'N' : 'Y')} disabled={!isEdit} />
              <label htmlFor='maintenanceChk'>{t('유지보수')}</label>
            </h5>
            {maintenanceChecked === 'Y' && (
              <div className='form-group'>
                <div className='form-item'>
                  <label htmlFor='maintenanceTitle'>{t('접수내역')}</label>
                  <input type='text' id='maintenanceTitle' value={form.maintenanceTitle} onChange={(e) => setForm({ ...form, maintenanceTitle: e.target.value })} placeholder={t('접수내역 입력')} />
                </div>
                <div className='form-item'>
                  <label htmlFor='maintenanceCauses'>{t('증상 및 원인')}</label>
                  <textarea id='maintenanceCauses' value={form.maintenanceCauses} onChange={(e) => setForm({ ...form, maintenanceCauses: e.target.value })} placeholder={t('증상 및 원인 입력')} />
                </div>
                <div className='form-item'>
                  <label htmlFor='maintenanceAction'>{t('조치내역')}</label>
                  <textarea id='maintenanceAction' value={form.maintenanceAction} onChange={(e) => setForm({ ...form, maintenanceAction: e.target.value })} placeholder={t('조치내역 입력')} />
                </div>
                <div className='form-item'>
                  <label htmlFor='useMaterial'>{t('자재(장비) 투입내역')}</label>
                  <textarea id='useMaterial' value={form.useMaterial} onChange={(e) => setForm({ ...form, useMaterial: e.target.value })} placeholder={t('자재(장비) 투입내역 입력')} />
                </div>
                <div className='form-item'>
                  <label htmlFor='bigo'>{t('비고')}</label>
                  <textarea id='bigo' value={form.bigo} onChange={(e) => setForm({ ...form, bigo: e.target.value })} placeholder={t('비고 입력')} />
                </div>
              </div>
            )}
          </div>

          <div className='form-group-wrap'>
            <h5>
              <input type='checkbox' id='installChk' checked={installChecked === 'Y'} onChange={() => setInstallChecked(installChecked === 'Y' ? 'N' : 'Y')} disabled={!isEdit} />
              <label htmlFor='installChk'>{t('설치/해체')}</label>
            </h5>

            {installChecked === 'Y' && (
              <div className='form-group'>
                <div className='form-item'>
                  <label htmlFor='installTitle'>{t('작업내역')}</label>
                  <input type='text' id='installTitle' value={form.installTitle} onChange={(e) => setForm({ ...form, installTitle: e.target.value })} placeholder={t('작업내역 입력')} />
                </div>

                <div className='form-group'>
                  <div className='form-item'>
                    <label htmlFor='test'>{t('일자별 작업수량')}</label>
                    <div className='quantity-date-list'>
                      {form.installDate?.map((date: string, idx: number) => (
                        <div className='quantity-date-item' key={idx}>
                          <input
                            type='date'
                            id='date'
                            value={convertMMDDYYYYToYYYYMMDD(date)}
                            onChange={(e) => {
                              setForm({
                                ...form,
                                installList: form.installList.map((item: any) => ({ ...item, ...(e.target.value === '' && { [`date${idx + 1}`]: '' }) })),
                                installDate: form.installDate.map((item: any, i: number) => (i === idx ? convertYYYYMMDDToMMDDYYYY(e.target.value) : item)),
                              });
                            }}
                            placeholder='MM/DD 입력'
                            style={{ width: '100%', paddingRight: '0.5rem' }}
                          />
                          {date && isIOS() && (
                            <button
                              className='date-remove-btn'
                              type='button'
                              onClick={() => {
                                setForm({
                                  ...form,
                                  installList: form.installList.map((item: any) => ({ ...item, [`date${idx + 1}`]: '' })),
                                  installDate: form.installDate.map((item: any, i: number) => (i === idx ? '' : item)),
                                });
                              }}
                            >
                              <span className='material-symbols-rounded' style={{ fontSize: '1.25rem' }}>
                                close
                              </span>
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {(form.installList || ['', '', '', '']).map((row: any, idx: number) => (
                  <div className='form-item install-form-item' key={idx}>
                    <label htmlFor={`name_${idx + 1}`}>
                      {t('품목')} {idx + 1}
                      {idx !== 0 && (
                        <span role='presentation' className='remove-row-btn' onClick={() => handleRemoveInstallRow(idx)}>
                          {t('지우기')}
                        </span>
                      )}
                    </label>
                    <div className='install-item'>
                      <div className='item-filed'>
                        <input
                          type='text'
                          id='name'
                          value={row.name}
                          onChange={(e) => setForm({ ...form, installList: form.installList.map((item: any, i: number) => (i === idx ? { ...item, name: e.target.value } : item)) })}
                          placeholder=' '
                        />
                        <label htmlFor='name'>
                          <span>{t('품명')}</span>
                        </label>
                      </div>
                      <div className='item-filed-group' style={{ display: 'flex', gap: '0.5rem', width: '100%' }}>
                        <select className='input-text' name='unit' value={row.unit || ''} onChange={(e: any) => handleInstallChange?.(idx, 'unit', e.target?.value || '')} disabled={!isEdit}>
                          {unitOptions.map((option: any) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {/* <div className='item-filed'>
                          <input
                            type='text'
                            id='unit'
                            value={row.unit}
                            onChange={(e) => setForm({ ...form, installList: form.installList.map((item: any, i: number) => (i === idx ? { ...item, unit: e.target.value } : item)) })}
                            placeholder=' '
                          />
                          <label htmlFor='unit'>
                            <span>{t('단위')}</span>
                          </label>
                        </div> */}
                        <div className='item-filed'>
                          <input
                            type='number'
                            id='qty'
                            value={row.qty}
                            onChange={(e) => setForm({ ...form, installList: form.installList.map((item: any, i: number) => (i === idx ? { ...item, qty: e.target.value } : item)) })}
                            placeholder=' '
                          />
                          <label htmlFor='qty'>
                            <span>{t('발주수량')}</span>
                          </label>
                        </div>
                      </div>

                      <select
                        className='input-text'
                        name='gubun'
                        value={typeof row.gubun === 'object' ? row.gubun?.gubun || '' : row.gubun || ''}
                        onChange={(e: any) => handleInstallChange?.(idx, 'gubun', { name: gubunOptions.find((option) => option.value === e.target?.value)?.label, gubun: e.target?.value })}
                        disabled={!isEdit}
                      >
                        {gubunOptions.map((option: any) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>

                      {form.installDate && form.installDate.some((date: string) => date !== '') && (
                        <div style={{ display: 'flex', gap: '0.5rem', width: '100%', flexWrap: 'wrap' }}>
                          {form.installDate.map(
                            (date: string, idx2: number) =>
                              date !== '' && (
                                <div className='item-filed' key={idx2} style={{ width: 'calc(50% - 0.25rem)' }}>
                                  <input
                                    type='number'
                                    id='date1'
                                    value={row[`date${idx2 + 1}`]}
                                    onChange={(e) =>
                                      setForm({ ...form, installList: form.installList.map((item: any, i: number) => (i === idx ? { ...item, [`date${idx2 + 1}`]: e.target.value } : item)) })
                                    }
                                    placeholder=' '
                                  />
                                  <label htmlFor={`date${idx2 + 1}`}>
                                    <span>{`${date.slice(0, 5)} 작업수량`}</span>
                                  </label>
                                </div>
                              )
                          )}
                        </div>
                      )}
                      <textarea
                        id='location'
                        value={row.location}
                        onChange={(e) => setForm({ ...form, installList: form.installList.map((item: any, i: number) => (i === idx ? { ...item, location: e.target.value } : item)) })}
                        placeholder={t('작업위치 입력')}
                      />

                      <textarea
                        id='bigo'
                        value={row.bigo}
                        onChange={(e) => setForm({ ...form, installList: form.installList.map((item: any, i: number) => (i === idx ? { ...item, bigo: e.target.value } : item)) })}
                        placeholder={t('비고 입력')}
                      />
                    </div>
                  </div>
                ))}

                <div role='presentation' className='add-row-button-wrapper' onClick={addInstallRow}>
                  <svg width='10' height='10' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' fill='currentColor' />
                  </svg>
                  {t('품목 행 추가')} ({t('현재 품목')} {form.installList?.length || 0}
                  {t('개')})
                </div>
              </div>
            )}
          </div>

          <div className='form-group-wrap'>
            <div className='form-group'>
              <div className='form-item file-upload-item'>
                <label htmlFor='file-upload'>{t('첨부파일')}</label>

                <div className='file-upload-wrap'>
                  <FileUploadButton
                    id='file-upload'
                    name='file-upload'
                    label='파일 첨부'
                    className='file-upload-label'
                    ico='upload'
                    accept='*'
                    multiple='Y'
                    color='blue'
                    handleChange={onChangeFileUpload}
                    allowAllFileTypes='all'
                  />
                  {form?.scheduleRFList?.length > 0 && (
                    <div className='file-wrap'>
                      <div className='file-inner'>
                        {form.scheduleRFList?.map((el: IFile) => (
                          <div key={el.fileId} className='file-item'>
                            <div className='file'>
                              <FormatImg format={el.fileFormat} />
                              <span>{el.fileName}</span>
                            </div>

                            <div className='flex-basic' style={{ gap: '0.5rem' }}>
                              <BtnRed className='file-btn' onClick={() => onClickFileRemove(el.fileId)}>
                                <span className='material-symbols-rounded'>close</span>
                              </BtnRed>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ServiceReportForm>
      )}
    </div>
  );
};

export default ServiceReport;
